export default function CoursesLevelATaskText({taskText, isHovered}) {
    // Used in CoursesLevelAItem to display LevelA
    // task text

    // BUILD
    return (
        <span className={`whitespace-pre-line font-medium text-[16px] ${isHovered ? "text-greyLight11" : "text-greyLight9"}`}>
                {taskText ?? "Erreur"}
        </span>
    );
}